// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CommissionDefaultAsset } from '@shared/utils/Enums/Constants';
import { AccountOperationType } from '../../AccountOperations';
/// Cодержит набор комиссий применительно к инструменту/группе
export class RevenueCommissionEntryItem {
    constructor() {
        this.Type = null;
        this.Name = null;
        this.ShortCommissionInfo = null;
        this.InstrumentTypeId = null;
        this.InstrumentId = null;
        this.AssetID = CommissionDefaultAsset.INSTRUMENT_QUOTING_CCY;
        this.Currency = null;
        this.UseInVAT = null;
        this.CommissionItems = [];
    }
    get TypeId() {
        return this.InstrumentTypeId;
    }
    get IsEmpty() {
        return this.CommissionItems.length === 0;
    }
    get IsCareOrder() {
        return this.Type === AccountOperationType.CareOrder;
    }
    GetCommission(param) {
        let value = 0;
        this.CommissionItems.forEach(function (revenueItem) {
            value += revenueItem.GetCommission(param);
        });
        return value;
    }
    ContainsCommission(type) {
        const items = this.CommissionItems;
        if (!(items === null || items === void 0 ? void 0 : items.length))
            return false;
        for (let i = 0; i < items.length; i++) {
            if (items[i].Type === type) {
                return true;
            }
        }
        return false;
    }
    GetLotsListForType(outLotsArray, commissionType, operationType) {
        const items = this.CommissionItems;
        if (!(items === null || items === void 0 ? void 0 : items.length))
            return;
        for (let i = 0; i < items.length; i++) {
            items[i].GetLotsListForType(outLotsArray, commissionType, operationType);
        }
    }
    IsSingleField(type) {
        for (let i = 0; i < this.CommissionItems.length; i++) {
            const item = this.CommissionItems[i];
            if (item.Type === type) {
                return item.IsSingleField();
            }
        }
        return false;
    }
    ShowOpenClose(type) {
        for (let i = 0; i < this.CommissionItems.length; i++) {
            const item = this.CommissionItems[i];
            if (item.Type === type) {
                return item.IsShowOpenClose();
            }
        }
        return false;
    }
    ContainsShort(type) {
        for (let i = 0; i < this.CommissionItems.length; i++) {
            const item = this.CommissionItems[i];
            if (item.Type === type) {
                return item.ContainsShort();
            }
        }
        return false;
    }
}
